import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import FormShell from "../../Organisms/FormShell/FormShell";
import DynamicFormik from "./../../Organisms/DynamicFormik/DynamicFormik";
import ContactBoxInf from "./../../Molecules/ContactBoxInf/ContactBoxInf";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const Contact = () => {
  const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />
			<div className="max-width">
				<div className="top-space-section">
					<CenteredHeader
						boldText={content[language].title}
						yellowText="FORESIGHT GPS"
					/>
				</div>

				<div className="flex wrap space-around top-space-section bottom-space-section contact-boxes-container">
					<ContactBoxInf
						adress="+58 (212) 313.50.00 Calle Pantín, Urb. Chacao, Caracas, Venezuela."
						place={content[language].oficina_1_title}
					/>
					<ContactBoxInf
						adress="+1(305) 398.38.6611890 SW 8th Street. Suite 404. Miami. Fl. 33184"
						place={content[language].oficina_2_title}
					/>
				</div>
			</div>
			<FormShell contact title={content[language].form_title}>
				<DynamicFormik
					buttonContent={content[language].form_button_text}
					field_1={content[language].form_fields[0]}
					field_2={content[language].form_fields[1]}
					field_3={content[language].form_fields[2]}
					field_4={content[language].form_fields[3]}
					field_5={content[language].form_fields[4]}
					field_6={content[language].form_fields[5]}
					field_7={content[language].form_fields[6]}
				/>
			</FormShell>
		</>
	);
};

export default Contact;
